import React from 'react';
import { ArrowRight, ArrowDown, PenLine, Palette, ShieldCheck, FlaskConical, BarChart3, Megaphone, Globe, Link2, Send, UserPlus, Calculator } from 'lucide-react';
import { muted, primary } from './mbApi';

const STEPS = [
  { icon: PenLine, title: 'Brief', who: 'Kaer', note: 'Audiens, angle, hook, offer, CTA, hipotesis', c: '#F77F00' },
  { icon: Palette, title: 'Bahan', who: 'Firzan', note: 'Alat AI team (luar Hub) / Creative Team → Add Version + link', c: '#E85D75' },
  { icon: ShieldCheck, title: 'Review', who: 'Firzan', note: 'Semak mesej, visual & CTA → Lulus / Kena ubah (wajib sebab)', c: '#A78BFA' },
  { icon: FlaskConical, title: 'Ujian', who: 'Azrai', note: 'Ujian Baru → invite link → Salin URL Iklan (LP + token) → Match Ad ID', c: '#38BDF8' },
  { icon: BarChart3, title: 'Hasil', who: 'Semua', note: 'Baca spend, join, CPS → Rekod Pembelajaran (Sync: manager)', c: '#34D399' },
];

const STATUSES = [
  { label: 'Kajian', note: 'Research idea' },
  { label: 'Brief Ready', note: 'Brief lengkap' },
  { label: 'Tengah Produce', note: 'Bahan dibuat' },
  { label: 'Ready to Test', note: 'Lulus review' },
  { label: 'Tengah Test', note: 'Ujian berjalan' },
  { label: 'Review Result', note: 'Nilai result' },
];

const LINK = [
  { icon: Megaphone, title: 'Iklan Meta', note: 'URL iklan + ?t=token' },
  { icon: Globe, title: 'Landing Page', note: 'Butang join → link CRM' },
  { icon: Link2, title: 'Link CRM', note: 'Padankan token → redirect ke invite Telegram' },
  { icon: Send, title: 'Invite Telegram', note: 'Link unik setiap ujian' },
  { icon: UserPlus, title: 'Join', note: 'Bot kesan join channel' },
  { icon: Calculator, title: 'CPS', note: 'Spend MYR ÷ join' },
];

const Arrow = ({ i }) => (
  <div className="flex items-center justify-center text-[hsl(var(--text-muted))] shrink-0" aria-hidden>
    <ArrowRight size={14} className="hidden md:block" />
    <ArrowDown size={14} className="md:hidden" />
    <span className="sr-only">{i}</span>
  </div>
);

const Row = ({ items, render, testid }) => (
  <div className="flex flex-col md:flex-row md:items-stretch gap-1.5 md:gap-2" data-testid={testid}>
    {items.map((it, i) => (
      <React.Fragment key={it.title || it.label}>
        {i > 0 && <Arrow i={i} />}
        {render(it, i)}
      </React.Fragment>
    ))}
  </div>
);

const Title = ({ children, sub }) => (
  <div className="mb-2.5">
    <p className={`text-xs font-semibold ${primary} uppercase tracking-wider`}>{children}</p>
    {sub && <p className={`text-[11px] ${muted}`}>{sub}</p>}
  </div>
);

const StepBox = (s, i) => (
  <div className="flex-1 min-w-0 rounded-lg border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-3 transition-transform duration-200 hover:-translate-y-0.5" style={{ borderTopColor: s.c, borderTopWidth: 3 }} data-testid={`mb-visual-step-${i + 1}`}>
    <div className="flex items-center gap-2">
      <s.icon size={15} style={{ color: s.c }} />
      <span className={`text-sm font-semibold ${primary}`}>{i + 1}. {s.title}</span>
    </div>
    <span className="inline-block mt-1.5 text-[10px] font-medium px-2 py-0.5 rounded-full" style={{ background: `${s.c}22`, color: s.c }}>{s.who}</span>
    <p className={`text-[11px] ${muted} mt-1.5 leading-snug`}>{s.note}</p>
  </div>
);

const StatusPill = (s, i) => (
  <div className="flex-1 min-w-0 rounded-lg border border-[hsl(var(--border))] px-2.5 py-2 text-center" data-testid={`mb-visual-status-${i + 1}`}>
    <p className={`text-xs font-semibold ${primary}`}>{s.label}</p>
    <p className={`text-[10px] ${muted}`}>{s.note}</p>
  </div>
);

const LinkBox = (s, i) => (
  <div className="flex-1 min-w-0 flex md:flex-col items-center md:text-center gap-2 md:gap-1 rounded-lg bg-[hsl(var(--surface))] border border-[hsl(var(--border))] px-2.5 py-2" data-testid={`mb-visual-link-${i + 1}`}>
    <s.icon size={15} className="text-[#38BDF8] shrink-0" />
    <div>
      <p className={`text-xs font-semibold ${primary}`}>{s.title}</p>
      <p className={`text-[10px] ${muted}`}>{s.note}</p>
    </div>
  </div>
);

export const WorkflowVisual = () => (
  <div className="space-y-6 py-1" data-testid="mb-workflow-visual">
    <div>
      <Title sub="Habis tahap awak → Serah ke PIC seterusnya">5 langkah utama & siapa buat</Title>
      <Row items={STEPS} render={StepBox} testid="mb-visual-steps" />
    </div>
    <div>
      <Title sub="Next Variation → balik ke Tengah Produce · Arkib = siap, simpan rujukan">Status papan kerja</Title>
      <Row items={STATUSES} render={StatusPill} testid="mb-visual-statuses" />
    </div>
    <div>
      <Title sub="Jangan letak link t.me terus dalam iklan — mesti lalu link CRM supaya join boleh dikira">Aliran link iklan ke Telegram</Title>
      <Row items={LINK} render={LinkBox} testid="mb-visual-link" />
    </div>
  </div>
);
